import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

const fmtDays = (d) => (d == null ? "—" : `${d} day${d === 1 ? "" : "s"}`);

export default function SubscriptionBanner() {
  const { user } = useAuth();
  const [limits, setLimits] = useState(null);

  // Pull trial limits when user is on trial — drives the "X of 3 drafts used" copy.
  useEffect(() => {
    if (!user || user.subscription_status !== "trial") {
      setLimits(null);
      return;
    }
    api.get("/subscription/status")
      .then((r) => setLimits(r.data?.trial_limits || null))
      .catch(() => setLimits(null));
  }, [user]);

  if (!user || typeof user !== "object") return null;
  const { subscription_status: s, days_left, must_report_outcome } = user;

  if (must_report_outcome) {
    return (
      <Link
        to="/reporting"
        data-testid="banner-report-outcome"
        className="block border border-amber-300 bg-amber-50 text-amber-900 px-4 py-3 text-sm hover:bg-amber-100"
      >
        <span className="gf-overline mr-2">Action Required</span>
        Report the outcome of your previously submitted proposals to keep generating new ones →
      </Link>
    );
  }
  if (s === "trial") {
    const used = limits?.drafts_used;
    const max = limits?.drafts_max;
    const usage = used != null && max != null
      ? ` · ${used}/${max} draft${max === 1 ? "" : "s"} used`
      : "";
    return (
      <Link
        to="/subscribe"
        data-testid="banner-trial"
        className="block border border-blue-300 bg-blue-50 text-blue-900 px-4 py-3 text-sm hover:bg-blue-100"
      >
        <span className="gf-overline mr-2">Free trial</span>
        {fmtDays(days_left)} left{usage}. Upgrade to send proposals + unlimited drafts ($14.99/mo) →
      </Link>
    );
  }
  if (s === "free") {
    return (
      <Link
        to="/subscribe"
        data-testid="banner-upgrade"
        className="block border border-zinc-300 bg-zinc-100 text-zinc-900 px-4 py-3 text-sm hover:bg-zinc-200"
      >
        <span className="gf-overline mr-2">Upgrade</span>
        Your trial has ended. Get a 30-day Premium pass for $14.99 →
      </Link>
    );
  }
  return null;
}
